import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { EVENT_TYPES } from '@/constants/device';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { useApiQuery } from './useApiQuery';

const TWO_HOURS_MS = 2 * 60 * 60 * 1000;

const useGetUserEventsTrend = ({
  useruuid,
  trendBody,
  enabled = true,
  resolveRawResponse = false,
}) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiQuery(
    ['getUserEventsTrend', useruuid, JSON.stringify(trendBody)],
    () =>
      new Promise((resolve, reject) => {
        userEventsApi.apiClient.callApi(
          '/hacloud/api/v1/user_events/{useruuid}/trend',
          'PUT',
          { useruuid },
          {},
          {},
          {},
          trendBody,
          [],
          ['application/json'],
          ['application/json'],
          Object,
          null,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              if (resolveRawResponse) {
                resolve(data);
                return;
              }

              const trendResults = get(data, 'trendResults', {});
              const { deviceUuid, eventType } = trendBody[0] || {};
              const requestedEventType = eventType?.[0];
              const trendResultsByDevice = get(trendResults, deviceUuid, {});
              const directTrendData = get(trendResultsByDevice, requestedEventType, null);
              const fallbackTrendData =
                requestedEventType ===
                EVENT_TYPES.FLUSH_SENSOR.ACCESSORY_STATE_UPDATE_TOILET_FLUSH_SENSOR_ACTIVE
                  ? Object.values(trendResultsByDevice || {})[0] || null
                  : null;
              const resolvedTrendData = directTrendData || fallbackTrendData;

              resolve(resolvedTrendData);
            },
            errorCallback: () => {
              reject(null);
            },
            failCallback: () => {
              reject(null);
            },
          })
        );
      }),
    {
      enabled: !!useruuid && Array.isArray(trendBody) && trendBody.length > 0 && enabled,
      staleTime: TWO_HOURS_MS,
      gcTime: TWO_HOURS_MS,
    }
  );
};

export default useGetUserEventsTrend;
